export const validateEachType = (text) => {
  if (text === null || text === undefined) return false;
  const v = String(text).trim();
  if (v === "") return false;

  const regex = /^(?:0|0,\d{1,3}|[1-9]\d{0,5}(?:,\d{0,3})?)$/;
  return regex.test(v);
};

export const validateEachTypeQuantity = (text) => {
  if (text === null || text === undefined) return false;
  const v = String(text).trim();
  if (v === "") return false;
  const regex = /^[1-9]\d{0,5}$/;
  return regex.test(v);
};

export const clearInputError = (type, setError) => {
  if (validateEachType(type)) {
    setError(null);
  }
};
